import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { useCallback, useState } from 'react'

import { ApiFuncParam, ApiRunFunc } from '@/modules'

import { useBaseAPI } from './baseApi.hook'

export type LazyOutput<T> = [ApiRunFunc, boolean, T | undefined, Error | undefined, () => void]

export function useLazyQuery<T>(url: string): LazyOutput<T> {
  const { instance, canceler } = useBaseAPI()

  const [isPending, setPending] = useState<boolean>(false)
  const [data, setData] = useState<T | undefined>(undefined)
  const [error, setError] = useState<Error | undefined>(undefined)

  const run = useCallback(
    (params?: ApiFuncParam) => {
      const config: AxiosRequestConfig = {}

      if (params) {
        config.params = params
      }

      setPending(true)

      instance
        .get(url, config)
        .then(({ data }: AxiosResponse<T>) => {
          setData(data)
          setError(undefined)
        })
        .catch((error: Error) => {
          setError(error)
          setData(undefined)
        })
        .finally(() => {
          setPending(false)
        })
    },
    [instance, url],
  )

  return [run, isPending, data, error, canceler.abort]
}
